import { Lci3SalesMetrics } from '@components/Dashboard/dashboardSlice/schemas/lci3Reports';
import { salesHighlightsText, FormatValue } from '@features/campaigns';
import { ReactNode } from 'react';
import { Highlights as BaseHighlights } from '@features/campaigns/components/Highlights';

type SalesHighlightsProps = {
  campaignName: string;
  uniqueUsers: number;
  salesMetrics: Lci3SalesMetrics;
};

const formatValue: FormatValue<ReactNode> = (value, key) => (
  <b key={key}>{value}</b>
);

export const SalesHighlights = (props: SalesHighlightsProps) => {
  return (
    <BaseHighlights sx={{ height: '100%' }}>
      {salesHighlightsText({
        metrics: {
          uniqueUsers: props.uniqueUsers,
          totalProjectedSales: props.salesMetrics.totalProjectedSales.total,
          incrementalSalesLift: props.salesMetrics.incrementalSalesLift.total,
          incrementalSales: props.salesMetrics.incrementalSales.total,
        },
        campaignName: props.campaignName,
        formatValues: {
          uniqueUsers: formatValue,
          totalProjectedSales: formatValue,
          incrementalSalesLift: formatValue,
          incrementalSales: formatValue,
        },
      })}
    </BaseHighlights>
  );
};
